import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
    providedIn: 'root'
})
export class PositionService extends ApiService {
    public getPositions(data: any) {
        return this.getOrderQueryParams(CONSTANTS.API.POSITION.GET_POSITIONS, data);
    }
    public closePosition(params: any, data: any) {
        return this.deleteOrderQueryParams(CONSTANTS.API.ORDER.CANCEL_ORDER, params, data);
    }
}
